import classNames from 'classnames';
import {Check} from 'lucide-react';
import * as React from 'react';

export interface ChoiceCardGroupProps {
    className?: string;
    children: React.ReactNode;
}

export const ChoiceCardGroup: React.FunctionComponent<ChoiceCardGroupProps> = ({className, children}: ChoiceCardGroupProps) => (
    <div role="radiogroup" className={classNames('mp-choice-card-group', className)}>
        {children}
    </div>
);

export interface ChoiceCardProps {
    glyph: string;
    name: string;
    meta: string;
    selected: boolean;
    onSelect: () => void;
    className?: string;
}

// A one-time, deliberate choice between two equally-weighted options, nothing pre-selected.
// Selection is carried by border + fill + an explicit tick, never by colour alone.
export const ChoiceCard: React.FunctionComponent<ChoiceCardProps> = ({glyph, name, meta, selected, onSelect, className}: ChoiceCardProps) => (
    <button type="button" role="radio" aria-checked={selected} className={classNames('mp-choice-card', className)} onClick={onSelect}>
        <span className="mp-choice-card__tick"><Check size={13}/></span>
        <span className="mp-choice-card__glyph">{glyph}</span>
        <span className="mp-choice-card__name">{name}</span>
        <span className="mp-choice-card__meta">{meta}</span>
    </button>
);

export interface ChoiceCardCaptionProps {
    className?: string;
    children: React.ReactNode;
}

export const ChoiceCardCaption: React.FunctionComponent<ChoiceCardCaptionProps> = ({className, children}: ChoiceCardCaptionProps) => (
    <p className={classNames('mp-choice-card-caption', className)}>{children}</p>
);
